import { useRef, useEffect, useState } from "react";
import Menu from "./menu";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import db from "../firebase";
import { addDoc, collection } from "firebase/firestore/lite";
const toastr = require('toastr')

mapboxgl.accessToken =
  "pk.eyJ1IjoiYXJ0dGVtcGxhdGUiLCJhIjoiY2s0M3I5ZHgzMGEzNDNucXM1cDd0dzl3cSJ9.a2wjLlxz8LzWj9nIoGsshw";

export default function Contact() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(-117.085358);
  const [lat, setLat] = useState(33.130360);
  const [zoom, setZoom] = useState(9);
  const [email, setEmail] = useState('')
  const [fullName, setFullName] = useState('')
  const [content, setContent] = useState('')
  const [sendingMsg, setSendingMsg] = useState(false);
  
  const sendMessage = async (e) => {
    e.preventDefault();
    if (fullName === '') {
      toastr.error("Input full name.", 'Error')
    }
    if (email === '') {
      toastr.error("Input email address.", 'Error')
    }
    if (content === '') {
      toastr.error("Input Message.", 'Error')
    }
    if (!sendingMsg && fullName !== '' && email !== '' && content !== '') {

      const userData = collection(db, "userData");
      setSendingMsg(true);
        await addDoc(userData, {
        name: fullName,
        email: email,
        content: content,
      });
      setSendingMsg(false);
      toastr.success("Thank you for your message. I will reply you soon.", 'Success')
      setEmail('')
      setContent('')
      setFullName('')
    }
    // console.log(result, "hello world");
  };
  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
    });
    map.current.on("move", () => {
      setLng(map.current.getCenter().lng.toFixed(4));
      setLat(map.current.getCenter().lat.toFixed(4));
      setZoom(map.current.getZoom().toFixed(2));
    });
  });
  return (
    <div className="col-12 col-md-12 col-xl-9">
      <div className="box-outer">
        <Menu />
        <div className="pb-0 pb-sm-2">
          <h1 className="title title--h1 title__separate">Contact</h1>
        </div>

        <div ref={mapContainer} className="map-container" />
        <h2 className="title title--h2">Contact Form</h2>

        <form
          id="contact-form"
          className="contact-form"
          data-toggle="validator"
        >
          <div className="row">
            <div className="form-group col-12 col-md-6">
              <input
                type="text"
                className="input form-control"
                id="nameContact"
                name="nameContact"
                placeholder="Full name"
                required="required"
                autoComplete="on"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                // onInvalid="setCustomValidity('Fill in the field')"
                // onKeyUp="setCustomValidity('')"
              />
              <div className="help-block with-errors"></div>
            </div>
            <div className="form-group col-12 col-md-6">
              <input
                type="email"
                className="input form-control"
                id="emailContact"
                name="emailContact"
                placeholder="Email address"
                required="required"
                autoComplete="on"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                // oninvalid="setCustomValidity('Email is incorrect')"
                // onKeyUp="setCustomValidity('')"
              />
              <div className="help-block with-errors"></div>
            </div>
            <div className="form-group col-12 col-md-12">
              <textarea
                className="textarea form-control"
                id="messageContact"
                name="messageContact"
                placeholder="Your Message"
                rows="4"
                required="required"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                // onInvalid={setCustomValidity('Fill in the field')}
                // onKeyUp={setCustomValidity('')}
              ></textarea>
              <div className="help-block with-errors"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 order-2 order-md-1 text-center text-md-start">
              <div id="validator-contact" className="hidden"></div>
            </div>
            <div className="col-12 col-md-6 order-1 order-md-2 text-end">
              <button type="button" className="btn" onClick={sendMessage}>
                {sendingMsg ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : (
                  <i className="font-icon icon-send"></i>
                )}{" "}
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
